import { toast } from "react-toastify";
import {
    REACT_TOAST_ACTION, RESPONSE_INTERNAL_SERVER_ERROR_CODE, RESPONSE_SUCCESS_CODE, RESPONSE_NO_RECORDS_FOUND_CODE,
    RESPONSE_INVALID_SENSOR_CODE, RESPONSE_EXISTING_EQUIPMENT_NAME_CODE, RESPONSE_LOCATION_BLOCKED_CODE,
    RESPONSE_EXPIRED_JWT_TOKEN_CODE
} from "./constants";
import _ from "lodash";

export const checkForAPISuccess = (statusCode) => _.isEqual(statusCode, RESPONSE_SUCCESS_CODE);

export const checkForExpiredJwtResponse = (statusCode) => _.isEqual(statusCode, RESPONSE_EXPIRED_JWT_TOKEN_CODE);

export const checkIfNoRecords = (statusCode) => _.isEqual(statusCode, RESPONSE_NO_RECORDS_FOUND_CODE);

export const showToast = (action, message, autoClose) => {
    toast[action](message,
        {
            position: "top-right",
            autoClose: autoClose || 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        }
    );
}

export const showInfoToast = (message, timer) => showToast(REACT_TOAST_ACTION.INFO, message, timer || 3000);

export const showSuccessToast = (message, timer) => showToast(REACT_TOAST_ACTION.SUCCESS, message, timer || 3000);

export const showErrorToast = (message, timer) => showToast(REACT_TOAST_ACTION.ERROR, message, timer || 3000);

export const responseToastHandler = (statusCode, onError, onSuccess, onFailure) => {
    switch (statusCode) {
        case RESPONSE_SUCCESS_CODE:
        case RESPONSE_NO_RECORDS_FOUND_CODE:    
            onSuccess && onSuccess.callBack();
            showToast(
                REACT_TOAST_ACTION.SUCCESS,
                onSuccess && onSuccess.message || "SUCCESS",
                onSuccess && onSuccess.timer || 3000
            );
            break;
        case RESPONSE_INTERNAL_SERVER_ERROR_CODE:
            onFailure && onFailure.callBack();
            showToast(
                REACT_TOAST_ACTION.ERROR,
                onFailure && onFailure.message || "FAILED",
                onFailure && onFailure.timer || 3000
            );
            break;
        case RESPONSE_INVALID_SENSOR_CODE:
            onError && onError.callBack();
            showToast(
                REACT_TOAST_ACTION.WARNING,
                onError &&  onError.message || "INVALID SENSOR",
                onError && onError.timer || 3000
            );
            break;
        case RESPONSE_EXISTING_EQUIPMENT_NAME_CODE:
            onError && onError.callBack();
            showToast(
                REACT_TOAST_ACTION.INFO,
                onError &&  onError.message || "ERROR OCCURED",
                onError && onError.timer || 3000
            )
            break;
        case RESPONSE_LOCATION_BLOCKED_CODE:
            onError && onError.callBack();
            showToast(
                REACT_TOAST_ACTION.ERROR,
                onError && onError.message || "Location is occupied",
                onError && onError.timer || 7000
            );
            break;
        default:
            onError && onError.callBack();
            showToast(
                REACT_TOAST_ACTION.INFO,
                onError &&  onError.message || "ERROR OCCURED",
                onError && onError.timer || 3000
            )
            break;
    }
}

export function convertCamelCaseToNormalCase(camelCaseString) {
    return camelCaseString
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, function(str) { return str.toUpperCase(); });
}

export function highlightSearchText(actualText, searchText)
{
    actualText = (actualText !== null && actualText !== undefined) ? actualText : "";
    var returnTxt = actualText;

    if(searchText !== "")
    {
        var regex = new RegExp("(" + searchText + ")", "gi");
        returnTxt = actualText.replace(regex, "<mark class='search-highlight'>$&</mark>");
    }
    return returnTxt;
}